import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, map, mapTo, tap } from 'rxjs/operators';

import { SearchService } from '../services/search/search.service';
import { Query } from './../../api';
import {
  isNotEmpty,
  luceneEscapeKeyValue,
  typedPluck,
  isNotNil,
  opFilterNotNil
} from './../../utils';

@Injectable({ providedIn: 'root' })
export class SelectFirstRootPageGuard implements CanActivate {
  constructor(private aSearchService: SearchService, private aRouter: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    // page query
    const query: Query = {
      q: luceneEscapeKeyValue('parentId', null),
      fq: [
        luceneEscapeKeyValue('hideFromNavigation', 'false'),
        'route:[* TO *]'
      ],
      sort: 'position asc',
      rows: 1
    };
    // find the best rout
    return this.aSearchService.getSitePages(query).pipe(
      typedPluck('sitePages'),
      filter(isNotEmpty),
      map((pages) => pages[0]),
      first(),
      typedPluck('route'),
      opFilterNotNil,
      tap((rte) => this.aRouter.navigateByUrl(rte)),
      mapTo(false)
    );
  }
}
